import axios from 'axios';
import { HOST_API, HOST_ATTENDANCE_API } from '../config';

const axiosInstanceDefault = axios.create({
  baseURL: HOST_API,
});

const axiosInstanceAttendanceAPI = axios.create({
  baseURL: HOST_ATTENDANCE_API,
});

axiosInstanceDefault.interceptors.response.use(
  (response) => response,
  (error) => Promise.reject((error.response && error.response.data) || error)
);

axiosInstanceDefault.interceptors.request.use((config) => {
  const jwt = localStorage.getItem('jwt');
  if (jwt) {
  // User is logged in. Set auth header on all requests
    config.headers.Authorization = `Bearer ${jwt}`
  } else {
    delete config.headers.Authorization;
    localStorage.removeItem('token')
  }
  return config;
}, (error) => Promise.reject(error));

// Add interceptors for axiosInstanceAttendanceAPI
axiosInstanceAttendanceAPI.interceptors.response.use(
  (response) => response,
  (error) => Promise.reject((error.response && error.response.data) || error)
);

axiosInstanceAttendanceAPI.interceptors.request.use((config) => {
  const jwt = localStorage.getItem('jwt');
  if (jwt) {
    config.headers.Authorization = `Bearer ${jwt}`;
  } else {
    delete config.headers.Authorization;
    localStorage.removeItem('token');
  }
  return config;
}, (error) => Promise.reject(error));

export { axiosInstanceDefault, axiosInstanceAttendanceAPI };

